import React from 'react';
import { Link } from 'react-router-dom';
import { find, forEach, get, map } from 'lodash-es';

import { getNameString } from '../../utils';

const getContratLabel = ({ contract, parties, multiple, strings }) => {
  let template = get(strings, 'salesroute.documents.contract', 'Contrat');
  let label;
  let covPartie;
  let subscrPartie;
  let strCovered;
  let strCovereds;
  let strSubscriber;

  if (multiple) {
    subscrPartie = find(parties, { ref: contract?.subscriber?.ref });

    if (subscrPartie) {
      if (contract?.covereds?.length > 1) {
        template = get(
          strings,
          'salesroute.documents.contract.template.multiple_contract.multiple_covered',
          'Contrat de __covereds__  souscrit par __subscriber__'
        );
        const separator = get(
          strings,
          'salesroute.documents.contract.template.multiple_contract.multiple_covered.separator',
          ', '
        );
        const lastSeparator = get(
          strings,
          'salesroute.documents.contract.template.multiple_contract.multiple_covered.last_separator',
          ' et '
        );

        const listCov = [];

        forEach(contract.covereds, covered => {
          covPartie = find(parties, { ref: covered?.party?.ref });

          if (covPartie) {
            listCov.push(getNameString(covPartie));
          }
        });

        const lastName = listCov.pop();

        strCovereds = `${listCov.join(separator)}${lastSeparator}${lastName}`;
        strSubscriber = getNameString(subscrPartie);
      } else {
        if (contract.covereds[0]?.party?.ref === subscrPartie.ref) {
          template = get(
            strings,
            'salesroute.documents.contract.template.multiple_contract.one_covered.same',
            'Contrat de __covered__'
          );

          strCovered = getNameString(subscrPartie);
        } else {
          covPartie = find(parties, { ref: contract.covereds[0]?.party?.ref });

          if (covPartie) {
            template = get(
              strings,
              'salesroute.documents.contract.template.multiple_contract.one_covered.distinct',
              'Contrat de __covered__  souscrit par __subscriber__'
            );

            strCovered = getNameString(covPartie);
            strSubscriber = getNameString(subscrPartie);
          }
        }
      }
    }
  } else {
    subscrPartie = find(parties, { ref: contract?.subscriber?.ref });

    if (subscrPartie) {
      template = get(
        strings,
        'salesroute.documents.contract.template.single_contract',
        'Contrat souscrit par __subscriber__'
      );

      strSubscriber = getNameString(subscrPartie);
    }
  }

  label = template.replace(/__covered__/, strCovered);
  label = label.replace(/__covereds__/, strCovereds);
  label = label.replace(/__subscriber__/, strSubscriber);

  return label;
};

/**
 *
 * @param {*} param0
 */
const documentsBlockTransform = ({ salesRoute, strings }) => {
  const contracts = get(salesRoute, 'contracts', []);

  const result = {
    documents: [{ test: 'Ok' }],
    contracts: map(contracts, contract => ({
      id: contract.id,
      component: text => <Link to={`/contracts/edit?quote_number${contract.quote_number}`}>{text}</Link>,
      label: getContratLabel({
        contract,
        parties: get(salesRoute, 'parties', []),
        multiple: contracts.length > 1,
        strings,
      }),
    })),
  };

  return result;
};

export default documentsBlockTransform;
